export enum FinanceStatusEnum {
  Unknown = 1,
  OnFinance = 2,
  FinanceClear = 3,
}
